// extracted by mini-css-extract-plugin
export var closeButton = "_p8-2";
export var closeButtonIcon = "_p8-3";
export var lightboxContent = "_p8-1";
export var lightboxOverlay = "_p8-0";